import { lazy } from 'react';

export const Questionnaire = {
  ProductDiscovery: lazy(() => import('./ProductDiscovery')),
  List: lazy(() => import('./List')),
};
